import React from 'react';
import { Box, Button } from '@mui/material';
import { useModal } from '../../../../hooks/Modal';
import { ModalTitle, ModalText } from './styled';

export const ModalPreCollection = () => {
  const { Modal, closeModal } = useModal();

  const handleCloseModal = () => {
    closeModal();
  };

  return (
    <Modal danger>
      <Box
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 16,
          maxWidth: '550px'
        }}
      >
        <ModalTitle>Atenção</ModalTitle>

        <ModalText>
          Esta solicitação será registrada como pré-coleta. Somente será
          programada após anexar o documento no Portal do Cliente.
        </ModalText>

        <Button
          type="button"
          variant="outlined"
          color="error"
          onClick={handleCloseModal}
          style={{ marginTop: 16, backgroundColor: '#fff' }}
        >
          OK
        </Button>
      </Box>
    </Modal>
  );
};
